import { startCase } from 'lodash';

import { AuthProvider } from 'types';

export const formatSSOProviderType = (provider: AuthProvider) =>
  provider === AuthProvider.Email ? '-' : startCase(provider);
